import SampleManage from "./-sampleManage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/opr/sampleManage")({
  staticData: {
    menuLabel: "寄样管理",
    showInMenu: true,
    menuGroup: "/opr",
    menuOrder: 4,
  },
  component: SampleManage,
});
